export const getAnalyticsItemCategoriesByTaxonomy = (
  taxonomy: string[] = [],
) => {
  const itemCategory: string[] = [];
  const itemCategory2: string[] = [];
  const itemCategory3: string[] = [];

  taxonomy.forEach((value) => {
    const splitTaxonomy = value.split('>') ?? [];

    if (splitTaxonomy[0] && !itemCategory.includes(splitTaxonomy[0])) {
      itemCategory.push(splitTaxonomy[0]);
    }
    if (splitTaxonomy[1] && !itemCategory2.includes(splitTaxonomy[1])) {
      itemCategory2.push(splitTaxonomy[1]);
    }
    if (splitTaxonomy[2] && !itemCategory3.includes(splitTaxonomy[2])) {
      itemCategory3.push(splitTaxonomy[2]);
    }
  });

  return {
    item_category: itemCategory.join(', '),
    item_category2: itemCategory2.join(', '),
    item_category3: itemCategory3.join(', '),
  };
};
